import React from "react";

import TeamInform from "./registerTeamForm";
import { Col, Row } from "react-bootstrap";
import PaymentForm from "./paymentForm";
import { ButtonDanger } from "../../ui/templates/buttons";
import PendingMembers from "./pendingMembers";
import SendEmailForm from "./sendEmailForm";
import { Box } from "@material-ui/core";
import { fontStyleBlack } from "../../ui/constants";

const findByRole = (team) => {
  const captainRoleExists = team?.user_roles?.some(value => value === 'Captain' || value?.role === 'Captain');
  return !captainRoleExists;
};
export default ({
  team,
  image,
  handleUpdateTeam,
  handleDeleteMember,
  handleApproveMember,
  carValues,
  racingBracket,
  handleImageChange,
  handleSendInvitation,
  handleCancelClick,
  selectedPrice,
  teamPaymentPrice,
  role,
  handleRoleChange,
  handleDeleteUserFromSlot,
  applicationId,
  locationId,
  cardNonceResponseReceived,
  handleSaveLicenseForSlot,
  handlePayClick,
  handleAssignPayment,
  handleLeaveTeam,
  handleGetInvoice,
  handleEventDetailsPush,
  handleTeamPaymentClick,
  handleDriverLicenseUpdate,
}) => {
  return (
    <div
      style={{
        overflow: "hidden",
      }}
    >
      {team && (
        <div>
          <Box>
            <Box className="fontStyleHeadingProfile fontStyleHeadingProfileWithButton">
              <Box>Team Profile</Box>
              {findByRole(team) && (
                <Box className="leave-team-button">
                  <ButtonDanger
                    text="Leave Team"
                    onClick={() => handleLeaveTeam()}
                  />
                </Box>
              )}
            </Box>
          </Box>

          <Col lg={12} xs={12} sm={12} md={12}>
            <TeamInform
              image={image}
              handleCreateTeam={handleUpdateTeam}
              handleImageChange={handleImageChange}
              team={team}
              carValues={carValues}
              racingBracket={racingBracket}
              handleSendInvitation={handleSendInvitation}
              handleApproveMember={handleApproveMember}
              handleDeleteMember={handleDeleteMember}
              handleRoleChange={handleRoleChange}
              cardNonceResponseReceived={cardNonceResponseReceived}
              teamPaymentPrice={teamPaymentPrice}
              handleCancelClick={handleCancelClick}
            />
            {team.team_info.is_past === false ? (
              <Row>
                <Col>
                  <Box>
                    <Box mt={-1}>
                      {" "}
                      <hr />
                    </Box>
                    <Box mb={1.5} className="fontStyle teamHeading">
                      Team Captain Admin
                    </Box>
                    <SendEmailForm
                      handleSendInvitation={handleSendInvitation}
                    />
                    <div className="row mt-2">
                      {team?.pending_members?.length > 0 && (
                        <div className="col-12">
                          <Box mb={2} style={fontStyleBlack}>
                            Approve Pending Team Members
                          </Box>
                          <Box style={{ overflowX: "auto" }}>
                            <PendingMembers
                              handleApproveMember={handleApproveMember}
                              handleDeleteMember={handleDeleteMember}
                              team={team}
                              role={role}
                              handleRoleChange={handleRoleChange}
                            />
                          </Box>
                        </div>
                      )}

                      <Box mt={2} mb={2} className="col-12">
                        <Box className="fontStyle">Team Payment</Box>
                        <Box mb={2} className="textStyles">
                          Team captains can pay for multiple driver entries
                          here. Payments can then be allocated to individuals
                          once they have joined the team.{" "}
                          <span className="bold">OR</span> Team members can pay
                          individually further below.
                        </Box>

                        <div className="submit-button">
                          <ButtonDanger
                            type="button"
                            className=" btn btn-danger"
                            onClick={() =>
                              handleTeamPaymentClick({
                                price: 105,
                              })
                            }
                            text="Team Payment"
                          ></ButtonDanger>
                        </div>
                      </Box>
                    </div>
                  </Box>
                  <Box className="containerDriverCrew">
                    <Box mt={-1}>
                      {" "}
                      <hr />
                    </Box>

                    <PaymentForm
                      handlePayClick={handlePayClick}
                      handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                      handleDeleteUserFromSlot={handleDeleteUserFromSlot}
                      team={team}
                      handleCreateTeam={handleUpdateTeam}
                      selectedPrice={selectedPrice}
                      applicationId={applicationId}
                      locationId={locationId}
                      handleAssignPayment={handleAssignPayment}
                      handleCancelClick={handleCancelClick}
                      cardNonceResponseReceived={cardNonceResponseReceived}
                      handleGetInvoice={handleGetInvoice}
                      findByRole={findByRole}
                      handleEventDetailsPush={handleEventDetailsPush}
                      handleDriverLicenseUpdate={handleDriverLicenseUpdate}
                    />
                  </Box>
                </Col>
              </Row>
            ) : (
              <h2 className="center">Payments are disabled</h2>
            )}
          </Col>
        </div>
      )}
    </div>
  );
};
